import { DialogContentText, styled } from "@mui/material";

const SuccessDialogContentText = styled(DialogContentText)(({ theme }) => ({
  color: theme.palette.success.main,
}));

export default SuccessDialogContentText;
